import React, { useEffect } from 'react';
import { observer } from 'mobx-react';
import { useLocation } from 'react-router-dom';
import { Typography, Box } from '@material-ui/core';

import { useStores } from '../../hooks/use-stores';
import { getPath } from '../../utils/getPath';

import Loader from '../../components/Loader';
import BackLink from '../../components/UI/BackLink';

import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
    document: { width: 35 },
});

const Instruction = observer(() => {
    const classes = useStyles();
    const { InstructionsStore: store, HeaderStore } = useStores();
    const { getInstruction, instruction, loader } = store || {};

    const { state } = useLocation();

    useEffect(() => {
        setTimeout(() => HeaderStore.setTitle(`${state.title}`), 0);
    }, [HeaderStore, state.title]);

    useEffect(() => {
        getInstruction(state.id);
    }, [getInstruction, state.id]);

    if (loader) return <Loader />;

    return (
        <div>
            <BackLink to="/instructions/" title="Все инструкции" />

            <Box display="flex" flexWrap="wrap" flexDirection="column">
                {instruction?.map(item => {
                    return (
                        <React.Fragment key={item.id}>
                            {item.file.type === 'mp4' && (
                                <Box mb={3}>
                                    <Box mb={1}>
                                        <Typography>{item.name}</Typography>
                                    </Box>
                                    <video width="540" height="auto" controls>
                                        <source src={item.file.url} type="video/mp4" />
                                    </video>
                                </Box>
                            )}
                            {item.file.type === 'pdf' && (
                                <Box display="flex" alignItems="center" mb={3}>
                                    <a href={item.file.url}>
                                        <img src={getPath('public/img/pdf-icon.svg')} alt="pdf-icon" className={classes.document} />
                                        <Box ml={1} component="span">
                                            <Typography component="span" color="textPrimary">
                                                {item.name}
                                            </Typography>
                                        </Box>
                                    </a>
                                </Box>
                            )}
                        </React.Fragment>
                    );
                })}
            </Box>
        </div>
    );
});

export default Instruction;
